<template>
  <!-- The new look: the same list in a card, with who, what and how paid in
       place of the client column, which is this page's own. -->
  <div v-if="plate" class="obj-card obj-table">
    <div class="obj-card__head">
      <h2>Kliendi töökäsud <small v-if="overview">· {{ overview.counts.events }}</small></h2>
    </div>
    <event-list :clientId="clientId" plate />
  </div>
  <event-list v-else :clientId="clientId" />
</template>

<script>
import EventList from '@/components/EventList.vue'

export default {
  components: { EventList },
  props: {
    clientId: {
      required: true
    },
    plate: {
      type: Boolean,
      default: false
    },
    overview: {
      type: Object,
      default: null
    }
  }
}
</script>
